import { jsx as _jsx } from "react/jsx-runtime";
import { usePlasmicCanvasContext } from "@plasmicapp/host";
import { useOfferRenderContext } from "../features/offer/OfferRenderContext.js";
import { useFormRenderContext } from "../features/form/FormRenderContext.js";
import { useAwaitContext } from "../shared/contexts/AwaitContext.js";
export const LGLeadProcessorProps = {
    presetPlasmicStudio: {
        type: "choice",
        options: ["PROGRESS", "FORM", "OFFER"],
        defaultValue: "FORM",
        displayName: "PlasmicStudio Preset",
    },
    progressSlot: {
        type: "slot",
        displayName: "Progress Slot",
    },
    formSlot: {
        type: "slot",
        displayName: "LGForm Slot",
    },
    offerSlot: {
        type: "slot",
        displayName: "LGPresetOffer Slot",
    },
};
export function LGLeadProcessor({ presetPlasmicStudio, className, progressSlot, formSlot, offerSlot, }) {
    const inEditor = usePlasmicCanvasContext();
    const { offer } = useOfferRenderContext();
    const { isAwaiting } = useAwaitContext();
    const { form } = useFormRenderContext();
    function presetSlot(preset) {
        switch (preset) {
            case "PROGRESS":
                return progressSlot;
            case "FORM":
                return formSlot;
            case "OFFER":
                return offerSlot;
            default:
                return null;
        }
    }
    if (!inEditor) {
        if (isAwaiting) {
            return (_jsx("div", { className: className, children: _jsx("div", { id: "wait-message", style: { minHeight: 1, minWidth: 1 }, children: progressSlot ? progressSlot : _jsx("p", { children: "\"Please, wait...\"" }) }) }));
        }
        if (form) {
            return _jsx("div", { className: className, children: formSlot });
        }
        if (offer) {
            return _jsx("div", { className: className, children: offerSlot });
        }
    }
    return _jsx("div", { className: className, children: presetSlot(presetPlasmicStudio) });
}
